export const bodyTextRadiusDefault = 0;

export const bodyTextColorDefault = 'hsla(180, 50, 50, 1)';
